// import { MOCK_FLIGHT_PLAN, MOCK_SECOND_FLIGHT_PLAN } from './flights';
import { MOCK_FLIGHT_PLAN } from './flights';
import {
  MOCK_ITINERARY_FLIGHT_PRODUCT,
  MOCK_ITINERARY_FLIGHT_PRODUCT_RETURN,
  MOCK_ITINERARY_EXCURSION_PRODUCT,
  MOCK_ITINERARY_EXCURSION_PRODUCT_KRISTIANSAND,
  MOCK_ITINERARY_EXCURSION_PRODUCT_FJORD,
  MOCK_ITINERARY_RENTAL_CAR_PRODUCT,
  MOCK_ITINERARY_ACCOMMODATION_PRODUCT,
  // MOCK_ITINERARY_ACCOMMODATION_PRODUCT_UPGRADE,
  MOCK_ITINERARY_EXCURSION_PRODUCT_UNSELECTED,
  MOCK_ITINERARY_ACCOMMODATION_PRODUCT2,
  MOCK_ITINERARY_ACCOMMODATION_PRODUCT3,
} from './products';

import type {
  Itinerary,
  ItineraryBlock,
  Destination,
  OpportunityOwner,
  Opportunity,
  CustomerPayment,
} from '../types/itinerary';

const MOCK_DESTINATION: Destination = {
  name: 'Norway',
  Content: [
    {
      type: 'main',
      header: 'The Land of Fjords and Adventure',
      subHeader: 'A Breathtaking Destination in the Far North',
      paragraph:
        'Norway is a land of stunning nature, dramatic fjords, and endless adventure. ' +
        'From the colorful city of Bergen to the majestic Norwegian fjords and the magical northern lights, ' +
        'Norway offers an unforgettable experience for nature lovers and explorers alike.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/1559411/pexels-photo-1559411.jpeg',
          id: '1',
        },
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/19210730/pexels-photo-19210730/free-photo-of-gorsa-brug-in-norvege-vue-de-drone-chute-d-eau-montagne-pont.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
          id: '2',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/2051027/pexels-photo-2051027.jpeg',
          id: '3',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/3580098/pexels-photo-3580098.jpeg',
          id: '4',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/1938359/pexels-photo-1938359.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '4',
        },
        {
          type: 'image',
          path: '	https://images.pexels.com/photos/3384815/pexels-photo-3384815.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '5',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/3011830/pexels-photo-3011830.jpeg?auto=compress&cs=tinysrgb&w=1200',
          id: '6',
        },
      ],
    },
    {
      type: 'secondary',
      header: 'A Land of Fjords, Mountains, and Coastal Beauty',
      paragraph:
        'Norway is a country of striking contrasts, where dramatic mountains meet deep blue fjords and ' +
        'endless coastlines. From the colorful wooden houses of Bergen to the scenic beauty of the ' +
        'Lofoten Islands, every corner of the country tells a unique story. The rugged terrain is perfect ' +
        'for outdoor enthusiasts, offering everything from peaceful forest trails to exhilarating mountain ' +
        'hikes. With its charming cities, picturesque villages, and untouched wilderness, Norway’s landscapes ' +
        'are as diverse as they are stunning.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/3510717/pexels-photo-3510717.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
          id: '1',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Climate',
      subHeader: 'Seasonal',
      paragraph:
        'Norway has a diverse climate, ranging from coastal temperate weather in the south to Arctic conditions in ' +
        'the north. Winters can be cold with heavy snowfall, while summers are mild and offer long daylight hours. ' +
        'The west coast experiences frequent rainfall, making for lush green landscapes and stunning fjords.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/sun.svg',
          id: '1',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Activities',
      subHeader: 'Outdoor Adventures',
      paragraph:
        'Norway is a paradise for outdoor enthusiasts. In winter, skiing, snowboarding, ' +
        'and dog sledding are popular, while summer offers hiking, kayaking, and scenic road trips. The fjords ' +
        'provide breathtaking boat tours, and wildlife lovers can go whale watching or spot reindeer in the north.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/surf.svg',
          id: '2',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Nature',
      subHeader: 'Stunning Landscapes',
      paragraph:
        'Norway is famous for its dramatic landscapes, including deep fjords, towering mountains, ' +
        'and endless forests. The country is home to spectacular sights like the Geirangerfjord, ' +
        'the Northern Lights, and the Lofoten Islands. With vast national parks and crystal-clear lakes, ' +
        'nature lovers will find endless beauty to explore.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/mountain.svg',
          id: '3',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Average Price',
      subHeader: 'Expensive, But Worth It',
      paragraph:
        'Norway is known for its high cost of living, with food, accommodation, and activities being ' +
        'relatively expensive. However, budget travelers can save by enjoying nature, ' +
        'staying in cabins or hostels, and cooking their own meals. The stunning ' +
        'landscapes and unique experiences make it a worthwhile investment.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/mountain.svg',
          id: '4',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Language',
      subHeader: 'Norwegian',
      paragraph:
        'Norwegian is the official language, but English is widely spoken, especially in tourist areas. ' +
        'Travelers will have no trouble communicating in hotels, restaurants, and public transportation, ' +
        'making it easy to navigate the country.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/sun.svg',
          id: '5',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Avg. Temperature',
      subHeader: '15 - 25°C',
      paragraph:
        'The average temperature in Norway depends on the season and location. In summer, ' +
        'coastal areas range from 15–25°C, while inland regions can be slightly warmer. ' +
        'Winters can be harsh, with temperatures dropping below freezing, especially in the north, ' +
        'where it can reach -20°C or lower.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/surf.svg',
          id: '6',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Food',
      subHeader: 'Fresh and Locally',
      paragraph:
        "Norwegian cuisine is influenced by the country's natural resources, with fresh seafood, lamb, " +
        'and wild berries playing a big role. Popular dishes include smoked salmon, reindeer stew, and ‘klippfisk’' +
        ' (dried cod). Traditional meals are hearty, but modern restaurants also offer international flavors.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/mountain.svg',
          id: '7',
        },
      ],
    },
    {
      type: 'destinationSummaryItem',
      header: 'Safety',
      subHeader: 'Very Safe',
      paragraph:
        'Norway is considered one of the safest countries in the world, with low crime rates ' +
        'and a strong social system. Travelers can explore both cities and remote areas with peace of mind. ' +
        'However, due to its rugged nature, outdoor safety is important—weather conditions can change rapidly, ' +
        'and proper preparation is key for hiking and winter activities.',
      RichContent: [
        {
          type: 'icon',
          path: 'icon/mountain.svg',
          id: '8',
        },
      ],
    },
    {
      type: 'localReviewer',
      header: 'Ingrid Olsen',
      subHeader: 'Resident of Norway',
      paragraph:
        'Norway is where nature feels endless, the air is crisp, and every season brings a new kind of magic. ' +
        'There’s nothing like standing by a fjord, feeling small in the best possible way.',
      RichContent: [
        {
          type: 'image',
          path: 'https://voja.travel/wp-content/uploads/2023/08/Ruth-footer-image.jpg',
          id: '9',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Wander More, Worry Less – Your Journey Starts Here!',
      paragraph:
        'At Travel Force, we believe that travel should be about adventure, relaxation, and creating ' +
        'unforgettable memories—not stress and hassle. That’s why we take care of every detail, ' +
        'from planning the perfect itinerary to securing the best deals on flights, accommodations, and experiences.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/1008155/pexels-photo-1008155.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
          id: '10',
        },
      ],
    },
  ],
};

// const MOCK_ITINERARY_CONNECTION_BLOCK: ItineraryBlock = {
//   id: '1',
//   name: 'Funchal-1', // ?
//   startDay: '1',
//   endDay: '1',
//   type: 'connection',
//   location: 'Funchal',
//   startDate: '2021-09-01',
//   endDate: '2021-09-01',
//   duration: 1,
//   ItineraryProducts: [MOCK_ITINERARY_FLIGHT_PRODUCT],
//   Content: [],
// };

const MOCK_ITINERARY_BLOCK: ItineraryBlock = {
  id: '15',
  name: 'Funchal-1', // ?
  startDay: '1',
  endDay: '5',
  type: 'regular',
  location: 'Greater Oslo Region',
  startDate: '2025-05-01',
  endDate: '2025-05-05',
  duration: 4,
  Content: [
    {
      type: 'main',
      header: 'Greater Oslo Region',
      subHeader: 'The Vibrant Heart of Norway',
      paragraph:
        'The Greater Oslo Region is Norway’s dynamic capital area, combining urban energy with easy access ' +
        'to nature. Oslo itself is a cultural hub, home to world-class museums, modern architecture, and a ' +
        'thriving food scene. Just beyond the city, visitors can explore forests, fjords, and charming small towns ' +
        'like Drøbak and Fredrikstad. Whether enjoying the waterfront at Aker Brygge or skiing in Nordmarka, this ' +
        'region offers a perfect mix of city life and outdoor adventure.',
      subParagraph:
        'Oslo blends history with modern innovation, from royal landmarks to sustainable urban developments. ' +
        'The city’s green initiatives, like electric ferries and bike-friendly streets, make it a ' +
        'leader in sustainability.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/12193146/pexels-photo-12193146.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '1',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/6729101/pexels-photo-6729101.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '2',
        },
        {
          type: 'image',
          path:
            'https://images.pexels.com/photos/8976688/pexels-photo-8976688.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2' +
            '' +
            '',
          id: '3',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/12166192/pexels-photo-12166192.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '4',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/19097433/pexels-photo-19097433/free-photo-of-landschap-tuinieren-huizen-woningen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '5',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/10811657/pexels-photo-10811657.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '6',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Get the Oslo Pass',
      paragraph:
        'Save money on public transport and free entry to museums like the Viking Ship Museum and the MUNCH Museum',
      RichContent: [
        {
          type: 'image',
          path:
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAYFBMVEU5mLb///8zlrWJvtDn8/' +
            'ZXo75nqsIqk7MtlLNeqMEkkbJAm7jw+PoulLT7/f7a6vBssce62OPH3+ikzNrf7fKZxtbS5u2x09/E3udMobz1+vuRwtN4tcqAus3j7/' +
            'S21uGYXEm5AAANcElEQVR4nO1d2ZaqOhDFckgMigiCgqj//5cHDGNSYZJA+iz2w133dNuYTYbaqVSqLGvFihUrVqxYsWLFihX/' +
            'FeBMCKGUpv+BpdsyPYCcbTe4fz7X6/Vz95OIkvPSbZoQQOzkuts0EIfP6L/pSna8njYInDChdOnGTQASeRg9jnfC/no/' +
            'Uvuu5pfhcvzT3QjkGbcTTPGxydLtHA3m3jr5pYif5G8OVWK3TMAmdu4fnI7U8iUiTnwLH4/wcpKHrrf/' +
            'Y0MVyFY0ELtPauYZS2UNI5EbXESOd+svLTnsKBIIXajbd6Bk/xE+ctr+laGaKpir0Pj3QV5LgFgP4WO3w58YqhQCR+gc1VrJDmJXP/' +
            '6AkmOJIEDbJhhQcbo6Ppg9HUkUihNw39pieck9mSzkZInWw9DJZtNYIQdUlGhx0EussESUPmYKOVmiXfu2k8LIdzMnsLE2oB+o' +
            'JVpHw4Qcsl68BjaQ7cU1ymtfo+YE0Je05luDvTDAXgPszKyQJdojGjWLzhCII8EAIQdUkmjjtRcm5IbMZh2QJVq8/WkVlIXcdd' +
            'yAmAaASDT7x6kj77scnyw1HTGJNsGYMkbIUWuEROuHH43rNIDzUxhMcTDhxkcWSHMLuR8kWj+MFrnTfPssowgTcjNxnECi9QMm' +
            '5GYYqulqLliIVKJpWs2BLCDkZInm6bTIdGYhh3jRbgem7/ssVMi99bkAMC/aDKZ4No+cDonW85sRj5yGo1VEokWz2eAZhBzqRZv' +
            '0G9qBmuAJuxGILNFm39IQRMhNxZFE0p5tCW9fKuTEvehrmnFEXuL4WOqsT97OfKZoCREm+U6PROsHSciF9s+NYc3Xpk+i9QNQwW' +
            'bdfn0ia/agt/zplyjkbr8NVLJtPOw4p4VQIRVyDe3o/UIRDrUnKQ8650dTyPnjKQLU9tmLWAgVUstRo5iMXhpYTdY/TRigNZB99' +
            'fbjsYvDOakIvgzqQA6IKp31GNk6u3rE1jiCTYruqE6smfq7YUOU4+xWq/y4mViqwIuRBNM+qJab1wiKtOxCJzLFSohgpdEYY/dJuV' +
            'YFBk5CDjiWnXgY3AtQLqQnMLUL024ovcbDl1NW7qmfZhw144jKxWJwK+1ikMbGjtEMrJSor4EjrRqkd6MZVsr5M7ATK2O4N3cWZm' +
            'DFdnE3sCdIsZfemTwLrdpaE0cD/7J4NWMl31yoptNA5VYuNEavpBnsgmEyjGE08u9mR7WHHSjc9j20AlBKu9QAdH6iE0DPbfs/KO' +
            'bTdmqGhBxfz+frSNQTlbIo2b5cm+HfbWfoaAdldrJ9bhPVM7QxBBJd89ER323FK2bbd74e+xYSq390No7Tvj4AexWu/IvKTauHIU' +
            'AjiuCOjkS74S2SPLe5am5jSNy6b3TnohS0MITovWnggnieoXnY4Yvf382QiCfc6CZHC0NbuhL6lj7VcIZle0ypZV0MJYK46dLBkB' +
            'Vz4/3wCq6SW5byD4X3z/d/ZHXbxbA05XH4uLS0RgPDone8iBFSBkeJdpMb4oCRdEFN9T/CoIMh5S2Pt4QRBrlMRrby0zME4P3mc' +
            '+cNUK5gL8LzuWRwsxYBcZEZ1MEwf48nfpQOzMVfpA6GlB8nhlWbOWNhovE+PCUsCw7Fbvp0MMynQrl+5rMylJxi0zMkfM95LH+e' +
            'f3fQjF0vvtjxthGqSToY2gIhoN8X6Ug0NDD8Woq4epfAP3ttfgGpnTtensihYztD4KMyqP4u3ybtpU9OPw+/T6y7ULnxEFdTu24' +
            'zT4lqLVWoQroVpx0N8Deii2FtPoCFMgS7cSAtKf+hDM+zMSTfJ55qfcj9XVfpC5jrVedDkslvZ5hbw2c1ufNhf5yBIXczVn7wfH' +
            'ENpE5K13g7+RSDVfx9O8Pc2tQGBvkurs4c1oKPlmvZiblrXXy59Htele4Pj/wU0hvGkPHuL/1glC89c1iLYvv/yjdEeSzDWyRw2' +
            'Fysr5UA9p2QoThP261FPijfuaGhuRaWaWhgWDhhAyCUkiLgTVxJMmdd/LTImVLeyYo+BMJyiGsxf+473WJTQg6c4E4+BdOhvAvfz' +
            '+4TBI98LQnx9p8+z9c2bJmHl+R6CTkE3Vd6bEM/8AvpjXiNdDCsn37nOIneCCLlTFCspTUInUjFcE9kk6mJoRBlkxGUThjpVoiy' +
            'U+2A1QwtECmiR9F6vBj00Ai98iz5Q+TYaJ9sLbsZNpRfto9Cj6J1eaLgWXIMXdTblu6ZvKIf30goRw+G6Wsq411iXxFNqsubCJT' +
            'ug8/jen/ZykgpINYhuH/uzz0alW27AvBHJP71cfUPylQL+vyl3wRztP1qIPAkdMrfNqH4VEcKO40MDcHKUIWVoTlYGaqwMjQ' +
            'HK0MVVobmYGWowsrQHKwMVVgZmoOVoQorQ3OwMlShK+qrw33Ut3VAaOZpamkbpL+Fc4srSg/DygN4jDoScUUtwcnUej0uu/' +
            'flulWmZyB7P7ztbqF/oIosfnqivmoXL+PL9twWfPdQX2Il1aVl5xrh7avuw94UaVvmiGu7tdyLipDoiRzN0w8HaSBAI43CB' +
            'Q1GnSVyTx0mn91CfeA330SvPnJwxpqpad7znVtIsYny2XOO73kxzp/mzc8TtF+QwZwfVMYn5TuwtDL07ve7l8chSBESHPy4+' +
            'IoeivGHXPZ25H4ctPl5fMkzsvfbm/ICnkaGSZZBPg/5wo4us2gpfviEdiKPUcnOrYDaHjYC+eHa9zdn+nIUtwY0MuRXqfJDe' +
            'vT90nwlvGK/LaJwSGZTCZbegjN0jl97pDSI2hnSj3IiQvEQOUC4HKWbne+CwqTmcS2bcBuJYQz1B2nvQ0/Zh6Q0Ztj9N1pec' +
            'Iy9LUUZlNdanPc9UmVU0ckwHV9AXCWFqoGbDWLJGtbC8bFR2LAWqsSFGhkGh8MhyU/asbWUt89RvoFmZp8b9hKsRiwAfh95H' +
            'nuIXmfnXRh8G+lg30GO9exWF0x30ipcYKMwiLMwdLBbmNwWOoQH32D5R9IxHgVVL6Htp+BW1b7eS923OGF5xfJp5hP2FQUOM' +
            'giz4IozI+6Vj2Q5IIU/iDA74PrUOS7C8OQj0TTFQhpTwlSdaO94qi5gEQ/KlT5Bg4v9HbuUKcJn9TJ8+Hc/2B6RS1sZ+Cy8B' +
            'L7PGxdLcWHpz688hoRbHJkhib+59SCznkswzFSb8gIiE5Nkyp2YPST2I0ppwuWN+AGuCC+JlW5++bqMyT/tFl+BaCNCSJNTpt' +
            '1wdvl+WuwgKDfap3xWoNp7IYZMTDq6EcMvqfgJ8dJNM0nVF3NbixaGuSJ97I8cJ96Jjc/QZp60WLY4dN9MzYbnPtDop2lhSHg' +
            'H2bk/rrhVI1CsF0bEbjCmq2zN4DuKFCt6GF4fj4fXEvFmP7wU1doC339/xD9g0dPbnU6n90eVKvRMkvsl/cguDFSpxvR4E7Ot' +
            'b1vyNqCkGbH3/QOkief0h7bVGphHGNi2aoNlTcBwXI6pAQBUMIifafndaRzDMu/L0KQocwOsoi+GZRyAUpj9kLJvFpSOhKHZH2' +
            'jhi5W1lFk4lzeqFf4+FUhhkJ0e02RJlNme4oENrV6N2RMRoLSoA5PKVV4UpT/bCJzLww/cZdsCWqqJruQci6LKSTdwGtYTRZm' +
            'cZYiWF5SQO19dqPY/BufCKpd8+YJnN6r+N9dg0OoIcsRcgip35kA9NCPKJqJHI12oLtiZmvySVK7IUTOp1ok7IxnWrraNzD5' +
            'Pqh2qeMXVBLAqA47kyOuLWsxFuHgudgHAagl6xmSg/YLWzk5u81Uk6QOgtduX3njZxWqelNiclOxZUvZaHIp0CXkAAOrpO95' +
            'GpNW3pApJh18WCWgewowsMDotxOIIPyZTp8fGnWzHh8FFYqcFEKHARfDrwBIo6qoi1xfsKFxhn8DLQiPhPHSBepI5gIJYMXCS' +
            'dPgA4hHDQoXBQSrfvZvqZZOtCYXBmSvkMtzcp/MhjSp8PymARGLRrnDa2aKpMm5fUBBfsYYKuiyRBslc0xGrgqyheB5a/nCW6' +
            'YgVQNTzxUgJy7fmEpaWVPtok9XN1LiXY/uZ6kkWoCBVPtRcUX7OUrKWXINs4+gvJjtfOWCsIPBMdTPlepI3HeVdsdLmswkNpC' +
            'z31C8XK8w9p8hIv19naXVMos0uhrExNNU7xuqqLlE3U1v93Blq4/YFJuR+XnJmqm/cExrqWMulzTVrig4AnbQWeToBxd22FkM' +
            '0DFg9+ZEv/Ty7ROsHIK9JhJz8nM0MEq0fEHk8XMjJEs1bqrIygt8Lg1Nb9KLN7SfpxE9CDpNoBnjXBcBZFHJO0HYHugb57czm' +
            'IBmGkUIOG+FG8sswwiMnS7TdUhKtH5i4KW8XcpgXrSOFweKQhVy8VS4ashftasL5XQeASs6x9wFtNibRjJ2ATSBCbi8KuVTR' +
            'minR+iEVYOIlTC+xWB6TD1ko/+EuWEBzJFo/yEvkJg797TGyreiY+A+pYlTay0u3eShkM9cC4yRaP8hSRQETJVo/ABWPVlE' +
            'sdKQ8DWQhJyFcfhP/G2Qh18BiXrQpwVwlx12wnBdtSgA53iXrkFXzSpTJ8v8cgJz3gVdjGYd3F4jBRdtHINUxjEZHN0ncQ2' +
            'Qx9p/RK5Fnsfs/ya1YsWLFihUrVqxY0YJ/Mmes25nLWBcAAAAASUVORK5CYII=',
          id: '1',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Explore Beyond the City',
      paragraph: 'Take a day trip to Drøbak for charming coastal views or hike in Nordmarka for a nature escape',
      RichContent: [
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/14643290/pexels-photo-14643290.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '2',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Visit the Opera House Rooftop',
      paragraph: 'Walk on the sloping rooftop of the Oslo Opera House for panoramic city and fjord view',
      RichContent: [
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/2360666/pexels-photo-2360666.jpeg?auto=compress&cs=tinysrgb&w=1200',
          id: '3',
        },
      ],
    },
  ],
  ItineraryProducts: [
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT,
    // MOCK_ITINERARY_ACCOMMODATION_PRODUCT_UPGRADE,
    MOCK_ITINERARY_RENTAL_CAR_PRODUCT,
    MOCK_ITINERARY_EXCURSION_PRODUCT,
    MOCK_ITINERARY_FLIGHT_PRODUCT,
  ],
};

const MOCK_ITINERARY_BLOCK_2: ItineraryBlock = {
  id: '2',
  name: 'Funchal-2',
  startDay: '5',
  endDay: '9',
  type: 'regular',
  location: 'Kristiansand',
  startDate: '2025-05-05',
  endDate: '2025-05-09',
  duration: 4,
  Content: [
    {
      type: 'main',
      header: 'Kristiansand',
      subHeader: 'Norway’s Southern Getaway',
      paragraph:
        'Kristiansand is Norway’s summer capital, known for its sunny coastline, sandy beaches, ' +
        'and family-friendly attractions. Located in the south, it’s a popular destination for ' +
        'Norwegians seeking a coastal retreat. Visitors can explore the charming old town of Posebyen, ' +
        'enjoy fresh seafood at Fiskebrygga, or visit Dyreparken, a zoo and amusement park loved by families. ' +
        'With its relaxed atmosphere and stunning seaside views, Kristiansand is a perfect spot for a ' +
        'laid-back escape.',
      subParagraph:
        'Beyond the beaches, Kristiansand offers a rich cultural scene with music festivals, art galleries, and ' +
        'the striking Kilden Performing Arts Centre. For nature lovers, the nearby Setesdal Valley and the coastal ' +
        'archipelago provide opportunities for kayaking, hiking, and island-hopping. The combination of lively city ' +
        'vibes and peaceful nature makes Kristiansand a unique and versatile destination.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/24863532/pexels-photo-24863532/free-photo-of-rood-huis-aan-de-rivier-in-de-noorse-kuststad.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '1',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/28429523/pexels-photo-28429523/free-photo-of-rustige-bosreflectie-in-kristiansand-noorwegen.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '2',
        },
        {
          type: 'image',
          path: 'https://media.istockphoto.com/id/1131408436/nl/foto/fiskebrygga-district-in-kristiansand-noorwegen.jpg?b=1&s=612x612&w=0&k=20&c=eIHdJ5kJp9rT-DGlIOGGNXbYNNtoPtx71Vn-S_SmdjQ=',
          id: '3',
        },
        {
          type: 'image',
          path: 'https://media.istockphoto.com/id/852237180/nl/foto/vuurtoren-oks%C3%B8y-fyr-ten-zuiden-van-kristiansand-in-noorwegen.jpg?b=1&s=612x612&w=0&k=20&c=X0oDm9EWCJ6BsXvxS3SHsRCQGil3xuyWp2M4L6BuJfg=',
          id: '4',
        },
        {
          type: 'image',
          path: 'https://media.istockphoto.com/id/902680286/nl/foto/avond-licht-ocean-rotsen-door-de-zee-warm-licht-en-sunstar-bezig-met-instellen-op-de-achtergrond.jpg?b=1&s=612x612&w=0&k=20&c=Uywa7U5efN7MASfJj4eYIk6PppQcD18cDO4AOna02bU=',
          id: '5',
        },
        {
          type: 'image',
          path: 'https://media.istockphoto.com/id/140265540/nl/foto/lighthouse-at-dawn-2.jpg?b=1&s=612x612&w=0&k=20&c=I5RqSK4InPoc8W3xDgXAGZ-BFTmBLOBEGoODMejoYvM=',
          id: '6',
        },
        {
          type: 'image',
          path: 'https://image.arrivalguides.com/1230x800/01/a1b909858bc87027d320c36c2d568736.jpg',
          id: '7',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Visit Dyreparken Early',
      paragraph:
        'Norway’s famous zoo and amusement park gets busy, so arrive early to enjoy the animals and attractions',
      RichContent: [
        {
          type: 'image',
          path: 'https://www.dyreparken.no/content/uploads/poi_dyr_elg-768x480.jpg',
          id: '1',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Try Fresh Seafood at Fiskebrygga',
      paragraph: 'The fish market offers fresh shrimp, fish soup, and scenic waterfront dining.',
      RichContent: [
        {
          type: 'image',
          path: 'https://assets.simpleviewcms.com/simpleview/image/fetch/c_fill,h_1080,w_1920/f_jpg/q_65/https://media.newmindmedia.com/TellUs/image/%3Ffile%3DFiskebrygga_Kristiansand_2__72286305.jpg&dh%3D533&dw%3D800&t%3D4',
          id: '2',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Explore the Southern Archipelago',
      paragraph: 'Take a boat trip to the nearby islands for quiet beaches and great hiking',
      RichContent: [
        {
          type: 'image',
          path: 'https://cms.goteborg.com/uploads/2021/06/Foto_Happy-Visuals_1908_tif_43.jpg',
          id: '3',
        },
      ],
    },
  ],
  ItineraryProducts: [
    // MOCK_ITINERARY_ACCOMMODATION_PRODUCT,
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT2,
    MOCK_ITINERARY_EXCURSION_PRODUCT_KRISTIANSAND,
  ],
};

const MOCK_ITINERARY_BLOCK_3: ItineraryBlock = {
  id: '3',
  name: 'Funchal-3',
  startDay: '9',
  endDay: '14',
  type: 'regular',
  location: 'Fjord Norway',
  startDate: '2025-05-09',
  endDate: '2025-05-15',
  duration: 6,
  Content: [
    {
      type: 'main',
      header: 'Fjord Norway',
      subHeader: 'The Gateway to the Fjords',
      paragraph:
        'Bergen, Norway’s second-largest city, is a picturesque coastal gem surrounded by mountains and fjords. ' +
        'Famous for its colorful Bryggen Wharf, rich history, and vibrant cultural scene, Bergen is a must-visit ' +
        'destination. Visitors can take the Fløibanen funicular for stunning views, explore the famous fish market, ' +
        'or use the city as a starting point for fjord adventures. With its mix of history, culture, and nature, ' +
        'Bergen is a city full of charm and character.',
      subParagraph:
        'Known as the "City of Seven Mountains," Bergen is a paradise for hikers and food lovers. Despite its ' +
        'frequent rain, the city’s cozy cafés, harbor views, and UNESCO-listed gastronomy make it a must-visit.',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://images.pexels.com/photos/2910598/pexels-photo-2910598.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '1',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/26065926/pexels-photo-26065926/free-photo-of-zee-stad-plaats-bezienswaardigheid.jpeg?auto=compress&cs=tinysrgb&w=1200&lazy=load',
          id: '2',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/29573938/pexels-photo-29573938/free-photo-of-vissersboten-aangemeerd-in-de-besneeuwde-arctische-baai.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '3',
        },
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/3922964/pexels-photo-3922964.jpeg?auto=compress&cs=tinysrgb&w=1200',
          id: '4',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Take the Fløibanen Funicular',
      paragraph: 'For the best city view, ride up Mount Fløyen, then hike or take the scenic walk back down',
      RichContent: [
        {
          type: 'image',
          path: 'https://images.pexels.com/photos/9246661/pexels-photo-9246661.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
          id: '1',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Pack for Rain',
      paragraph: 'Bergen is one of Europe’s rainiest cities, so bring waterproof clothing and shoes',
      RichContent: [
        {
          type: 'image',
          path: 'https://lh3.googleusercontent.com/p/AF1QipP-r7PzfmkmcuS29kz_FowaaZRj3a1Ry1Jrz1fh=s680-w680-h510',
          id: '2',
        },
      ],
    },
    {
      type: 'tip',
      header: 'Visit Bryggen Early or Late',
      paragraph: 'This historic UNESCO site is less crowded in the morning or evening, perfect for photos',
      RichContent: [
        {
          type: 'image',
          path: 'https://lh3.googleusercontent.com/p/AF1QipNLZS6OspHh2wJDxWFDK3tnK6chKG_BfVsphCD2=s680-w680-h510',
          id: '3',
        },
      ],
    },
  ],
  ItineraryProducts: [
    // MOCK_ITINERARY_ACCOMMODATION_PRODUCT,
    MOCK_ITINERARY_ACCOMMODATION_PRODUCT3,
    MOCK_ITINERARY_EXCURSION_PRODUCT_FJORD,
    MOCK_ITINERARY_EXCURSION_PRODUCT_UNSELECTED,
    MOCK_ITINERARY_FLIGHT_PRODUCT_RETURN,
  ],
};

export const MOCK_OPPORTUNITY_OWNER: OpportunityOwner = {
  id: '1',
  name: 'Carin Coppens',
  Content: [
    {
      type: 'main',
      header: 'Carin Coppens',
      subHeader: 'Your travel agent',
      paragraph:
        'At Travel Force, we specialize in crafting personalized travel experiences tailored to your ' +
        'unique interests and preferences. Whether you seek adventure, culture, or relaxation, we design ' +
        'customized itineraries that turn your dream trip into reality',
      RichContent: [
        {
          type: 'image',
          subType: 'header',
          path: 'https://voja.travel/wp-content/uploads/2023/06/employee-ruth.png',
          id: '1',
        },
      ],
    },
  ],
};

export const MOCK_OPPORTUNITY: Opportunity = {
  id: '1',
  name: 'Norway',
  owner: MOCK_OPPORTUNITY_OWNER,
};

export const MOCK_CUSTOMER_PAYMENT: CustomerPayment = {
  id: '1',
  amount: 3954.12,
  status: 'Paid',
  type: 'Down Payment',
  currencyIsoCode: 'USD',
};

export const MOCK_ITINERARY: Itinerary = {
  id: '1',
  Destination: MOCK_DESTINATION,
  ItineraryBlocks: [
    // MOCK_ITINERARY_CONNECTION_BLOCK,
    MOCK_ITINERARY_BLOCK,
    MOCK_ITINERARY_BLOCK_2,
    MOCK_ITINERARY_BLOCK_3,
  ],
  status: 'open',
  startDate: '2021-09-01',
  endDate: '2021-09-03',
  // flightPlans: [MOCK_FLIGHT_PLAN, MOCK_SECOND_FLIGHT_PLAN],
  flightPlans: [MOCK_FLIGHT_PLAN],
  personalMessage:
    'We are thrilled to present your personalized itinerary for an unforgettable journey through Norway! ' +
    'From the vibrant streets of Oslo to the coastal charm of Kristiansand and the breathtaking fjords of Bergen, ' +
    'this trip is designed to immerse you in the best of Norway’s culture, history, and natural beauty. Get ready ' +
    'to explore scenic landscapes, indulge in delicious Nordic cuisine, and create memories that will last a ' +
    'lifetime. Should you have any questions or wish to make any adjustments, we are here to ensure your trip ' +
    'is nothing short of perfect. We can’t wait to welcome you to Norway!',
  duration: 14,
  amountOfTravelers: 2,
  amountOfAdults: 2,
  registeredTravelers: [],
  price: 9960.6,
  priceAdults: 9960.6,
  priceKids: 0,
  hasSplitPayments: false,
  customerPayments: [MOCK_CUSTOMER_PAYMENT],
  Opportunity: MOCK_OPPORTUNITY,
};
